//Name,Symbol,Weight,Last Trade,Chg,% Chg
// prettier-ignore
export default [
  ["Apple Inc", "AAPL", 11.007,174.94,0.15, "(0.09%)"],
  ["Microsoft Corp", "MSFT", 9.61,316.98,-0.03, "(-0.01%)"],
  ["Amazon.com Inc", "AMZN", 5.401,129.31,0.19, "(0.14%)"],
  ["NVIDIA Corp", "NVDA", 4.101,415.74,-0.36, "(-0.09%)"],
  ["Meta Platforms Inc", "META", 3.729,299.42,0.34, "(0.11%)"],
  ["Tesla Inc", "TSLA", 3.285,244.13,-0.75, "(-0.31%)"],
  ["Alphabet Inc", "GOOGL", 3.133,130.49,0.24, "(0.18%)"],
  ["Alphabet Inc", "GOOG", 3.085,131.49,0.24, "(0.18%)"],
  ["Broadcom Inc", "AVGO", 2.896,833.04,3.96, "(0.48%)"],
  ["Costco Wholesale Corp", "COST", 2.137,557.85,-0.74, "(-0.13%)"],
  ["PepsiCo Inc", "PEP", 2.096,174.84,-0.43, "(-0.25%)"],
  ["Adobe Inc", "ADBE", 2.033,511.42,-1.48, "(-0.29%)"],
  ["Cisco Systems Inc", "CSCO", 1.887,53.68,0.11, "(0.20%)"],
  ["Comcast Corp", "CMCSA", 1.633,45.30,-0.01, "(-0.01%)"],
  ["Netflix Inc", "NFLX", 1.478,379.89,0.08, "(0.02%)"],
  ["T-Mobile US Inc", "TMUS", 1.43,140.18,0.83, "(0.60%)"],
  ["Advanced Micro Devices Inc", "AMD", 1.348,96.09,-0.11, "(-0.12%)"],
  ["Texas Instruments Inc", "TXN", 1.264,161.00,0.69, "(0.43%)"],
  ["Intel Corp", "INTC", 1.26,34.19,0.01, "(0.01%)"],
  ["Amgen Inc", "AMGN", 1.251,271.18,3.48, "(1.30%)"],
  ["Intuit Inc", "INTU", 1.226,509.00,0.43, "(0.08%)"],
  ["Honeywell International Inc", "HON", 1.103,188.67,-1.12, "(-0.59%)"],
  ["QUALCOMM Inc", "QCOM", 1.046,107.53,-0.16, "(-0.14%)"],
  ["Applied Materials Inc", "AMAT", 0.982,136.32,0.15, "(0.11%)"],
  ["Booking Holdings Inc", "BKNG", 0.941,3, 19.20,-43.30, "(-1.42%)"],
  ["Starbucks Corp", "SBUX", 0.926,93.80,0.12, "(0.12%)"],
  ["Intuitive Surgical Inc", "ISRG", 0.867,288.50,0.30, "(0.10%)"],
  ["Automatic Data Processing Inc", "ADP", 0.854,239.45,0.10, "(0.04%)"],
  ["Mondelez International Inc", "MDLZ", 0.835,71.25,0.82, "(1.16%)"],
  ["Gilead Sciences Inc", "GILD", 0.814,75.47,0.46, "(0.61%)"],
  ["Vertex Pharmaceuticals Inc", "VRTX", 0.794,353.67,4.14, "(1.18%)"],
  ["Regeneron Pharmaceuticals Inc", "REGN", 0.763,828.09,3.25, "(0.39%)"],
  ["Analog Devices Inc", "ADI", 0.752,176.82,1.34, "(0.76%)"],
  ["Lam Research Corp", "LRCX", 0.702,620.00,0.89, "(0.14%)"],
  ["Micron Technology Inc", "MU", 0.646,68.90,0.02, "(0.03%)"],
  ["Palo Alto Networks Inc", "PANW", 0.604,228.70,0.19, "(0.08%)"],
  ["Synopsys Inc", "SNPS", 0.587,447.12,0.27, "(0.06%)"],
  ["Charter Communications Inc", "CHTR", 0.581,441.88,-3.33, "(-0.75%)"],
  ["MercadoLibre Inc", "MELI", 0.562,1,275.50,-1.47, "(-0.11%)"],
  ["PayPal Holdings Inc", "PYPL", 0.559,57.90,0.02, "(0.03%)"],
  ["CSX Corp", "CSX", 0.54,31.23,0.03, "(0.09%)"],
  ["Cadence Design Systems Inc", "CDNS", 0.539,230.83,0.17, "(0.07%)"],
  ["KLA Corp", "KLAC", 0.53,456.11,4.29, "(0.95%)"],
  ["PDD Holdings Inc ADR", "PDD", 0.521,95.93,-0.01, "(-0.01%)"],
  ["Marriott International Inc/MD", "MAR", 0.505,193.90,-0.46, "(-0.23%)"],
  ["Monster Beverage Corp", "MNST", 0.498,54.48,-0.04, "(-0.08%)"],
  ["Airbnb Inc", "ABNB", 0.491,132.09,-0.11, "(-0.08%)"],
  ["O'Reilly Automotive Inc", "ORLY", 0.485,936.67,0.65, "(0.07%)"],
  ["Cintas Corp", "CTAS", 0.446,505.27,0.52, "(0.10%)"],
  ["ASML Holding NV", "ASML", 0.438,585.00,-2.10, "(-0.36%)"],
  ["NXP Semiconductors NV", "NXPI", 0.434,196.76,-0.04, "(-0.02%)"],
  ["Workday Inc", "WDAY", 0.414,235.55,4.73, "(2.05%)"],
  ["Lululemon Athletica Inc", "LULU", 0.405,386.36,-1.69, "(-0.44%)"],
  ["Keurig Dr Pepper Inc,KDP", 0.404,33.25,0.13, "(0.39%)"],
  ["Fortinet Inc", "FTNT", 0.401,58.29,0.05, "(0.09%)"],
  ["Marvell Technology Inc", "MRVL", 0.388,52.38,0.08, "(0.14%)"],
  ["PACCAR Inc", "PCAR", 0.38,84.97,0.04, "(0.04%)"],
  ["Old Dominion Freight Line Inc", "ODFL", 0.38,401.01,0.35, "(0.09%)"],
  ["Autodesk Inc", "ADSK", 0.379,204.07,0.03, "(0.01%)"],
  ["Kraft Heinz Co/The", "KHC", 0.368,34.27,0.11, "(0.31%)"],
  ["Microchip Technology Inc", "MCHP", 0.36,77.00,-0.08, "(-0.10%)"],
  ["Copart Inc", "CPRT", 0.358,43.26,0.10, "(0.22%)"],
  ["American Electric Power Co Inc", "AEP", 0.357,79.23,0.06, "(0.08%)"],
  ["Paychex Inc", "PAYX", 0.355,113.01,0.06, "(0.06%)"],
  ["Exelon Corp", "EXC", 0.35,40.28,0.07, "(0.16%)"],
  ["ON Semiconductor Corp", "ON", 0.341,93.87,0.06, "(0.06%)"],
  ["AstraZeneca PLC ADR", "AZN", 0.339,67.35,-0.49, "(-0.72%)"],
  ["Seagen Inc", "SGEN", 0.336,212.18,-1.52, "(-0.71%)"],
  ["Ross Stores Inc", "ROST", 0.335,111.71,0.05, "(0.04%)"],
  ["Moderna Inc", "MRNA", 0.331,100.32,0.33, "(0.33%)"],
  ["Biogen Inc", "BIIB", 0.326,257.93,0.25, "(0.10%)"],
  ["Crowdstrike Holdings Inc", "CRWD", 0.319,162.85,0.28, "(0.17%)"],
  ["IDEXX Laboratories Inc", "IDXX", 0.316,439.41,3.72, "(0.85%)"],
  ["Baker Hughes Co", "BKR", 0.307,35.44,0.04, "(0.10%)"],
  ["Constellation Energy Corp", "CEG",0.307,110.41,0.05, "(0.04%)"],
  ["Cognizant Technology Solutions Corp","CTSH",0.303,70.19,0.58,"(0.83%)"],
  ["Verisk Analytics Inc", "VRSK", 0.303,242.05,0.10, "(0.04%)"],
  ["Dexcom Inc", "DXCM", 0.3,88.30,0.80, "(0.92%)"],
  ["Trade Desk Inc/The", "TTD", 0.293,76.38,0.03, "(0.03%)"],
  ["Xcel Energy Inc", "XEL", 0.284,59.76,0.03, "(0.04%)"],
  ["Electronic Arts Inc", "EA", 0.279,118.38,-0.63, "(-0.53%)"],
  ["CoStar Group Inc", "CSGP", 0.277,78.18,0.12, "(0.15%)"],
  ["GLOBALFOUNDRIES Inc", "GFS", 0.273,57.21,0.38, "(0.67%)"],
  ["Fastenal Co", "FAST", 0.268,54.32,0.11, "(0.20%)"],
  ["Atlassian Corp", "TEAM", 0.253,196.01,0.55, "(0.28%)"],
  ["GE HealthCare Technologies Inc", "GEHC", 0.252,63.78,-0.56, "(-0.86%)"],
  ["Warner Bros Discovery Inc", "WBD", 0.244,11.09,-0.02, "(-0.14%)"],
  ["Diamondback Energy Inc", "FANG", 0.235,150.70,0.13, "(0.09%)"],
  ["Datadog Inc", "DDOG", 0.23,88.81,0.05, "(0.06%)"],
  ["ANSYS Inc", "ANSS", 0.227,300.60,-2.31, "(-0.76%)"],
  ["eBay Inc", "EBAY", 0.203,43.22,0.09, "(0.20%)"],
  ["Dollar Tree Inc", "DLTR", 0.201,104.77,0.27, "(0.25%)"],
  ["Align Technology Inc", "ALGN", 0.2,297.25,-1.31, "(-0.44%)"],
  ["Zscaler Inc", "ZS", 0.188,151.80,0.09, "(0.06%)"],
  ["Illumina Inc", "ILMN", 0.183,132.31,-0.13, "(-0.10%)"],
  ["Walgreens Boots Alliance Inc", "WBA", 0.161,21.18,0.06, "(0.28%)"],
  ["Zoom Video Communications Inc", "ZM", 0.151,68.57,-0.29, "(-0.41%)"],
  ["Enphase Energy Inc", "ENPH", 0.148,120.41,0.49, "(0.41%)"],
  ["Sirius XM Holdings Inc", "SIRI", 0.137,4.05,0.02, "(0.50%)"],
  ["JD.com Inc ADR", "JD", 0.117,30.43,0.02, "(0.05%)"],
  ["Lucid Group Inc", "LCID", 0.102,5.14,0.03, "(0.49%)"],
];
